import { ICode } from './interfases';

export const getDefaultCodes = (): Array<ICode> => {
  const defaultCode: ICode = { value: '', ref: null };

  return [
    { ...defaultCode },
    { ...defaultCode },
    { ...defaultCode },
    { ...defaultCode },
  ];
};
